export const BACKEND_URL =
  process.env.REACT_APP_STAGE && process.env.REACT_APP_STAGE === 'live'
    ? 'https://api.burmester.services'
    : 'https://test.api.burmester.services'

export const JWT_USER_TOKEN = 'user-token'

// export const BACKEND_URL = 'http://localhost:8080' // config for local dev
